// LoadingOverlay.tsx
import Spinner from '@cloudscape-design/components/spinner';
import React from 'react';

interface LoadingOverlayProps {
  theme?: 'light' | 'dark';
}

export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ theme = 'light' }) => (
  <div style={{
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: theme === 'light' ? 'rgba(255,255,255,0.6)' : 'rgba(0,0,0,0.6)',
    zIndex: 9999,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: 'auto',
  }}>
    <Spinner size="large" />
  </div>
);